/**
 * withSystemSettings
 * HOC for wrapping the provided component with DepartmentsProvider
 */

import React from 'react'

import DepartmentsProvider from './departments-provider'

export default function withDepartments (WrappedComponent) {
  return function DepartmentsProviderHOC(props) {
    return (
      <DepartmentsProvider {...props}>
        <WrappedComponent {...props} />
      </DepartmentsProvider>
    )
  }
}
